
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .q-pa-lg(style="width: 500px")
    q-field.users-detail-field.q-mb-md(
      :error="errors.name !== false"
      :error-label="errors.name || ''"
    )
      q-input(
        ref="focus"
        v-model.trim="model.name"
        :disable="id === config.auth.id"
        float-label="名前"
        data-lpignore="true"
      )

    q-field.users-detail-field.q-mb-md(
      :error="errors.username !== false"
      :error-label="errors.username || ''"
    )
      q-input(
        v-model.trim="model.username"
        :disable="id === config.auth.id"
        float-label="ログインID"
        data-lpignore="true"
      )

    q-field.users-detail-field.q-mb-md
      QSelectMod(
        v-model.trim="roleKey"
        :disable="id === config.auth.id"
        float-label="権限"
        :options="roleOptions"
      )

    //- 更新モード
    template(v-if="id")
      q-field.users-detail-field.q-mb-md(:error="errors.password !== false")
        q-input(
          ref="focus2"
          v-model.trim="model.password"
          float-label="パスワード(変更時のみ入力してください)"
          type="password"
          data-lpignore="true"
        )

      q-field.users-detail-field.q-mb-md(
        :error="errors.password !== false"
        :error-label="errors.password || ''"
      )
        q-input(
          v-model.trim="password2"
          float-label="パスワード(確認のためもう一度入力してください)"
          type="password"
          data-lpignore="true"
        )

      .flex.justify-end
        q-btn.q-mx-sm(
          v-if="id !== config.auth.id"
          color="negative"
          flat
          @click="destroy"
        ) 削除

        q-btn.q-mx-sm(
          color="primary"
          flat
          @click="confirm"
        ) 更新

        q-btn.q-mx-sm(
          color="dark"
          flat
          v-close-overlay
        ) キャンセル

    //- 新規モード
    template(v-else)
      q-field.users-detail-field.q-mb-md(:error="errors.password !== false")
        q-input(
          v-model.trim="model.password"
          float-label="パスワード"
          type="password"
          data-lpignore="true"
        )

      q-field.users-detail-field.q-mb-lg(
        :error="errors.password !== false"
        :error-label="errors.password || ''"
      )
        q-input(
          v-model.trim="password2"
          float-label="パスワード(確認のためもう一度入力してください)"
          type="password"
          data-lpignore="true"
        )

      .flex.justify-end
        q-btn.q-mx-xs(
          color="primary"
          flat
          @click="confirm"
        ) 追加

        q-btn.q-mx-sm(
          color="dark"
          flat
          v-close-overlay
        ) キャンセル

</template>

<script>
import {get} from 'lodash-es'

import {mapAuto} from 'helpers/vuex-bind'
import RoleOption from 'models/RoleOption'

import QSelectMod from 'components/QSelectMod'
import AxiosMixin from 'mixins/axios'

const defaults = Object.entries({
  name: '',
  username: '',
  password: '',
  role: '',
  store_code: '',
})

export default {
  components: {QSelectMod},
  mixins: [AxiosMixin],

  props: {
    users: Array,
  },

  data() {
    return {
      visible: false,
      id: null,

      model: {},
      original: {},

      roleKey: '',
      password2: '',

      errors: {
        name:     false,
        username: false,
        password: false,
      },
    }
  },

  computed: {
    ...mapAuto(['config', 'roleOptions']),
  },

  methods: {
    show(data = {}) {
      this.id = data.id

      this.model = defaults.reduce((acc, [key, val]) => ({...acc,
        [key]: key in data ? data[key] : val,
      }), {})

      this.roleKey = RoleOption.key(data) || 'admin'
      this.password2 = ''

      this.original = {...this.model}
      this.clearError()
      this.visible = true

      setTimeout(() => {
        this.$refs.focus.disable
          ? this.$refs.focus2.focus()
          : this.$refs.focus.focus()
      }, 0)
    },

    hide() {
      this.visible = false
    },

    confirm() {
      const role = this.roleOptions.find(role => role.key === this.roleKey)
      if(role != null) {
        Object.assign(this.model, role.data)
      }

      this.clearError()

      if(this.model.password !== this.password2) {
        this.errors.password = 'パスワードが一致しません'
        return
      }

      this.$emit('confirm', this.id, this.model)
    },

    async destroy() {
      try {
        await this.$q.dialog({
          title: '削除の確認',
          message: '「' + this.original.name + '」を削除します。よろしいですか？',
          ok:     {label: '削除',       color: 'negative'},
          cancel: {label: 'キャンセル', color: 'dark', flat: true},
        })
        this.$emit('delete', this.id)
      }
      catch(e) {this.$handler(e)}
    },

    clearError() {
      this.errors = Object.keys(this.errors).reduce(
        (a, k) => ({...a, [k]: false}), {})
    },

    handler(e) {
      this.$handler(e, errors => {
        this.errors = Object.entries(this.errors).reduce(
          (a, [k, v]) => ({...a, [k]: get(errors, [k, '0'], v)}), {})
      })
    },
  },
}
</script>

<style lang="sass">
.users-detail-field
  height: 5rem
</style>
